import lightbox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.min.css';

lightbox.option({
  'albumLabel': "Zdjęcie %1 z %2"
});